import originalUuid from 'uuid';

const uuid = () => originalUuid().replaceAll('-', '');

export default uuid;
